export const UPDATE_ADMIN_PROFILE = {
  method: 'PUT',
  url: '/v1/update-profile',
};
